import React from 'react';
import styled from 'styled-components';
import anchorme from 'anchorme';
// import { isValidHexColor } from 'components/PageBuilder/PageBuilderSideBar/BlockSettings/domain';
import BlockTextContainer, { BlockSubTextContainer } from '../BlockComponents/BlockTextContainer';
// import InnerHTML from 'dangerously-set-html-content';
import { IEmbedBlockPreviewProps } from './IEmbedBlockPreviewProps';
import BlockContainer from '../BlockComponents/BlockContainer';
import BlockContentContainer from '../BlockComponents/BlockContentContainer';
import { v4 as uuidv4 } from 'uuid';
import EmbedPreview from 'components/EmbedPreview/EmbedPreview';

const EmbedContentContainer: any = styled.div`
  margin-top: 10px;
  width: 100%;
  height: fit-content;
  overflow-y: auto;
  border-radius: 0 0 4px 4px;
`;

const EmbedContentWrapper: any = styled.div`
  display: flex;
  justify-content: center;
  height: fit-content;

  div:first-child {
    position: relative;
  }

  *:first-child {
    width: 100% !important;
  }
`


const EmbedBlockPreview: React.FC<IEmbedBlockPreviewProps> = (props) => {  

  const [InnerHTMLRenderId, setInnerHTMLRenderId] = React.useState<string>(uuidv4());
  
  React.useEffect(() => {
    setInnerHTMLRenderId(uuidv4());
  }, [props.blockData.embed_url]);

  return (
    <>
    <BlockContainer
    design={props.blockData.design}
    >
        <BlockContentContainer
        className={`${props.view ? props.view : ''}`}
        design={props.blockData.design}
        >
            <BlockTextContainer
            design={props.blockData.design}
            pageStyles={props.pageStyles}
            textKey="heading"
            fallbackTextColor="#FFFFFF"
            dangerouslySetInnerHTML={{
                __html: anchorme(props.blockData.heading),
            }}
            />


            <BlockSubTextContainer
            design={props.blockData.design}
            pageStyles={props.pageStyles}
            textKey="subtext"
            fallbackTextColor="#FFFFFF"
            dangerouslySetInnerHTML={{
                __html: anchorme(props.blockData.subtext),
            }}
            />

            <EmbedContentContainer
            >
                <EmbedContentWrapper
                >
                    <EmbedPreview
                    key={InnerHTMLRenderId}
                    html={props.blockData.embed_url ? props.blockData.embed_url : ''}
                    />
                </EmbedContentWrapper>
            </EmbedContentContainer>
        </BlockContentContainer>
    </BlockContainer>
    </>
  )
}

export default EmbedBlockPreview;